<template >
  
    <b-card>
      
        <h3>Guias de confeccion</h3>
        <b-row>
            <b-button  
                v-for="item in listSku" 
                :key="item.sku+item.idPedido" 
                :variant="item.variant" 
                class="btn-options" 
                :class="{ 'option-select': item.sku === skuSelect}" 
                @click="cambioSku(item)" 
                style="height: 100%;"
                >
                  {{item.titulo}}: <b>{{item.cantidad}}</b>

                  <template v-for="dataUser in confeccionUsers">
                  <span
                    v-if="item.sku === dataUser.sku && item.idPedido == dataUser.idPedido"
                    :key="dataUser.idUser + '-sku'"
                    class="b-avatar badge-minimal badge-light-primary rounded-circle pull-up"
                    :class="{'margin-avatar': getIndexAvatar(dataUser, item) == 0, 'margin-avatar-multiple': getIndexAvatar(dataUser, item) > 0}"
                    style="border: 2px solid white;"
                  >
                    <span class="b-avatar-img" v-b-tooltip.hover.bottom="dataUser.nombre">
                      <img :src="require('@/assets/images/avatars/'+dataUser.img)" alt="avatar">
                    </span>
                  </span>
                </template>
            </b-button>
        </b-row>
        <div class="seleccion-sku">
          <h4><span>{{ tituloSelect }}</span> Color</h4>
          <b-row>
              <b-button v-for="item in coloresSku" :key="item.name" :variant="item.variant" class="btn-options" :class="{ 'option-select': item.nombre === colorSelect}" @click="cambioColor(item.nombre)" style="height: 100%;">
                {{item.nombre}}: {{item.cantidad}}
                  <template v-for="dataUser in confeccionUsers">
                    <span
                      v-if="item.sku === dataUser.sku && item.nombre == dataUser.color && item.idPedido == dataUser.idPedido"
                      :key="dataUser.idUser + '-sku'"
                      class="b-avatar badge-minimal badge-light-primary rounded-circle pull-up"
                      :class="{'margin-avatar': getIndexColorAvatar(dataUser, item) == 0, 'margin-avatar-multiple': getIndexColorAvatar(dataUser, item) > 0}"
                      style="border: 2px solid white;"
                    >
                      <span class="b-avatar-img" v-b-tooltip.hover.bottom="dataUser.nombre">
                        <img :src="require('@/assets/images/avatars/'+dataUser.img)" alt="avatar">
                      </span>
                    </span>
                  </template>
              </b-button>
              <b-button variant="outline-danger" class="btn-options ml-auto" @click="reportModal(null)">Reportar {{tituloSelect}}</b-button>
          </b-row>
        </div>
      
        <!--<h4>Personas</h4>
        <b-row style="margin-left: 10px; margin-bottom: 10px">
            <span v-for="item in confeccionUsers" :key="item.idUser" class="b-avatar badge-minimal badge-light-primary rounded-circle" style="width: 40px; height: 40px;">
              <span class="b-avatar-img">
              <img :src="require('@/assets/images/avatars/'+item.img)" alt="avatar">
              </span>
            </span>
        </b-row>-->
         
        
        <b-table
            :items="letras"
            :fields="columnasTable"
            class="table table-borderless"
            outlined
            striped
            responsive
            ref="tableCorte"
            >
            <!-- table-borderless-->

            <!--<template #thead-top="data">
              <b-tr>
                <b-th variant="secondary" colspan="1">Terminado</b-th>
                <b-th variant="secondary" colspan="2">Mano</b-th>
                <b-th variant="primary" colspan="2">Confeccion</b-th>
              </b-tr>
            </template>-->

            <!--<template v-for="(grupo,index) in gruposImagenes" v-slot:[`cell(${grupo.name})`]="data">
              <b-row style="position: relative; display: flex; justify-content: center;" :key="index">
                <span v-for="(item,index) in getGrupoImagenes(data.item, grupo.name)" :key="grupo.name+index">

                  <div class="container" style="margin-bottom: -15px;">
                    <p style="text-align: center; position: relative;top: 0%;">{{item.nombreCategoria}}</p>
                  </div>

                  <b-col cols="auto" style="margin: 2px; padding: 10px; display: flex; justify-content: center; align-items: center;">
                    <b-row :class="{'div-imagenes': item.finalizado, 'div-proceso': item.iniciado, 'div-bloqueado': item.bloqueado} " @click="tareaFinalizada(item)">
                      <div class="d-flex flex-column align-items-center">
                        <img :id='item.requierePrevio' :src="item.img" style="max-width: 100px;" alt="">

                        <template v-for="dataUser in confeccionUsers">
                    <span
                      v-if="item.idTareaPedido === dataUser.tarea"
                      :key="dataUser.idUser + '-sku'"
                      class="b-avatar badge-minimal badge-light-primary rounded-circle pull-up"
                      :class="{'margin-avatar': getIndexTareaAvatar(dataUser, item) == 0, 'margin-avatar-multiple': getIndexTareaAvatar(dataUser, item) > 0}"
                      style="border: 2px solid white;"
                    >
                      <span class="b-avatar-img" v-b-tooltip.hover.bottom="dataUser.nombre">
                        <img :src="require('@/assets/images/avatars/'+dataUser.img)" alt="avatar">
                      </span>
                    </span>
                  </template>

                      </div>
                    </b-row>
                    
                  </b-col>
                  
                </span>
              </b-row>
            </template>-->


             <template v-for="(grupo,index) in gruposImagenes" v-slot:[`cell(${grupo.name})`]="data">
              <b-row style="position: relative; display: flex; justify-content: center;" :key="index">
                <span v-for="(item,index) in getGrupoImagenes(data.item, grupo.name)" :key="grupo.name+index">
                  <div class="container" style="margin-bottom: -15px;">
                    <p style="text-align: center; position: relative;top: 0%;">{{item.nombreCategoria}}</p>
                  </div>
                  <b-col cols="auto" style="margin: 2px; padding: 10px; display: flex; justify-content: center;
    align-items: center;">
                    <div :class="{'div-imagenes': item.finalizado, 'div-proceso': item.iniciado, 'div-bloqueado': item.bloqueado} " style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%;" @click="tareaFinalizada(item)"></div>
                    <img :id='item.requierePrevio' :src="item.img" style="max-width: 100px;" alt="">
                  </b-col>
                  <template v-for="dataUser in confeccionUsers">
                    <span
                      v-if="item.idTareaPedido === dataUser.tarea"
                      :key="dataUser.idUser + '-sku'"
                      class="b-avatar badge-minimal badge-light-primary rounded-circle pull-up"
                      :class="{'margin-avatar': getIndexTareaAvatar(dataUser, item) == 0, 'margin-avatar-multiple': getIndexTareaAvatar(dataUser, item) > 0}"
                      style="border: 2px solid white;"
                    >
                      <span class="b-avatar-img" v-b-tooltip.hover.bottom="dataUser.nombre">
                        <img :src="require('@/assets/images/avatars/'+dataUser.img)" alt="avatar">
                      </span>
                    </span>
                  </template>
                </span>
              </b-row>
            </template>

            <template #cell(letraimg)="data">
              <p style="text-align: center"><b>{{data.item.letra}} - {{data.item.titulo}}</b></p>
                <div style="position: relative; display: flex; justify-content: center; align-items: center; padding: 10px">
                    <div :class="{'div-imagenes': data.item.finalizado, 'div-bloqueado': data.item.bloqueado} " style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></div>
                    <img :src="data.item.img" style="max-width: 100px;" alt="">
                </div>
            </template>
            <template #cell(options)="data">
              <div style="text-align: center" @click="reportModal(data.item)">
                <i class="fa-solid fa-triangle-exclamation" style="font-size: 30px; color: lightgray"></i>
              </div>
            </template>
        </b-table>
        <!--</div>-->

        <b-modal
            id="modal-report"
            ref="modal-report"
            ok-only
            ok-title="Accept"
            centered
            hide-footer
            size="LG"
            :title="'Reportar problema con ' + tareaReport.nombreCategoria"
        >

        <b-row class="match-height" v-if="reportTipo == 0">
          <b-col cols="6">
            <div class="div-reporte" @click="seleccionarTipoReport(1)">
              Reporte
            </div>

          </b-col>
          <b-col cols="6">
            <div class="div-reporte" @click="seleccionarTipoReport(2)">
              Cambiar Stock
            </div>

          </b-col>
        </b-row>

          <b-row class="match-height" v-if="reportTipo != 0">
              <b-col cols="12">
                  <b-row class="match-height">
                  <!--categoria-->
                  <!--Descripcion-->
                    <b-col cols="12">

                        <b-form-textarea
                            id="descripcionReportInput"
                            ref="descripcionReportInput"
                            placeholder="Descripcion"
                            rows="4"
                            v-model="descripcionReport"
                          />
                    </b-col>
                  </b-row>
                  <b-row class="match-height" style="margin-top: 10px" v-if="reportTipo == 2">
                  <!--Descripcion-->
                    <b-col cols="6">

                        <label for="sb-disabled">Cantidad a fabricar</label>
                        <b-form-spinbutton
                          class="spinDisable"
                          id="sb-disabled"
                          v-model="cantidadObjetivo"
                          disabled
                        />
                    </b-col>
                    <b-col cols="6">
 
                       <label for="sping-cortado">Cantidad fabricar</label>
                        <b-form-spinbutton
                          id="sping-cortado"
                          v-model="cantidadCortada"
                          
                        />
                    </b-col>
                  </b-row>
                  <br>
                  <b-button variant="outline-primary" @click="guardarReporte()">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <span class="align-middle"> Crear reporte</span>
                  </b-button>

              </b-col>

          </b-row>

        </b-modal>

    </b-card>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable, BFormInput, BFormGroup, BRow, BCol, BAvatar, BAvatarGroup} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex';


  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
        BAvatar,
        BAvatarGroup
    },
    data () {
      return {
        columnasTable: [
        {
          key: "mano1",
          label: "Mano",
          sortable: true,
        },{
          key: "mano2",
          label: "Mano",
          sortable: true,
        },{
          key: "aparado1",
          label: "Aparado",
          sortable: true,
        },{
          key: "aparado2",
          label: "Aparado",
          sortable: true,
        },{
          key: "img",
          label: "Terminado",
          sortable: true,
        },{
          key: "options",
          label: "Reportes",
          thStyle: { width: "5%" },
        }],
        tareas: [],
        allTareas: [],
        coloresSku: [],
        colorSelect: null,
        listSku: [],
        skuSelect: null,
        idPedidoSelect: 0,
        skuConfeccion: [],
        tituloSelect: "",
        tareaReport: {nombreCategoria: ""},
        descripcionReport: "",
        reportTipo: 0,
        cantidadObjetivo: 0,
        cantidadCortada: 0,
        timer: "",
        countDown: 30,
        allLetras: [],
        letras: [],
        gruposImagenes: [],
        userId: 0,
        userName: '',
        allUsers: null,
        idTareaTrabajando: 0
      }
    },
    methods:{
      getIndexColorAvatar(dataUser, data){

        let cantidad = 0;
        let stopCount = false;

        this.confeccionUsers.forEach(user => {
          if(data.sku === user.sku && data.nombre == user.color){
            if(user.idUser == dataUser.idUser)
            {
              stopCount = true;
            }              
            else
            {
              if(!stopCount)
                cantidad++;
            }              
          }
        });

        return cantidad;

      },
      getIndexAvatar(dataUser, data){

        let cantidad = 0;
        let stopCount = false;

        this.confeccionUsers.forEach(user => {
          if(data.sku === user.sku){
            if(user.idUser == dataUser.idUser)
            {
              stopCount = true;
            }              
            else
            {
              if(!stopCount)
                cantidad++;
            }              
          }
        });

        return cantidad;

      },
      getIndexTareaAvatar(dataUser, data){

        let cantidad = 0;
        let stopCount = false;

        this.confeccionUsers.forEach(user => {
          if(data.idTareaPedido === user.tarea){
            if(user.idUser == dataUser.idUser)
            {
              stopCount = true;
            }              
            else
            {
              if(!stopCount)
                cantidad++;
            }              
          }
        });

        return cantidad;

      },
      async loadItems(autoload = false){

        axios.post("/uso", {seccion:"confeccionTrabajo"});
        //try {
            /*Obtengo los sku de gestionar dia*/
            const responseConfeccionDia = await axios.get("/taller/master/confeccion/dia");
            let resConfeccionDia = responseConfeccionDia.data;

            resConfeccionDia.sort((a, b) => parseInt(a.paso) - parseInt(b.paso));
                        
            const sku = resConfeccionDia.map(element => this.eliminarUltimoApartado(element.sku))
            this.skuConfeccion = resConfeccionDia;

            const responsePieza = await axios.post("/confeccion/tarea/list", {list: [...new Set(sku)] });
            const resPieza = responsePieza.data;

            this.allTareas = resPieza;

            let ids = [];

            if (Array.isArray(resPieza)) {
              ids = resPieza.map(element => element.idLetra)
            }
            else
            {
              return;
            }

            const responseLetras = await axios.post("/confeccion/letra/id", {list: [...new Set(ids)] });
            const resLetras = responseLetras.data;

            this.allLetras = resLetras;

            //console.log(this.allLetras);

            this.allLetras.sort((a, b) => Number(a.orden) - Number(b.orden));

            /*Obtengo el estado de las piezas de ese pedido*/
            let skuPedido = this.skuConfeccion.flatMap(dato => {
              return this.allTareas
                .filter(tarea => tarea.sku === this.eliminarUltimoApartado(dato.sku))
                .map(tarea => ({ idPedido: dato.idPedido, idTarea: tarea.id, color: dato.sku.split('-').pop() }));
            });
            

            const responseTareaEstado = await axios.post("/taller/pieza/pedido/confeccion", {info: skuPedido });
            const resTareaEstado = responseTareaEstado.data;

            this.allTareas = resTareaEstado.map(tarea => {
              const finalizado = tarea.terminado > 0;
              return { ...tarea, finalizado };
            });

            this.allTareas.forEach((obj2) => {
              const obj1 = resPieza.find((obj1) => obj1.id === obj2.id);
              if (obj1) {
                obj2.sku = obj1.sku;
              }
            });

            this.allTareas.sort((a, b) => Number(a.orden) - Number(b.orden));

            //Quito el color del articulo y quito los duplicados (para mostrar arriba, el color ira dentro de cada uno)
            const articuloSinDuplicar = [];

            this.skuConfeccion.forEach(articulo => {
              const skuSinUltimoApartado = this.eliminarUltimoApartado(articulo.sku);
              
              if (!articuloSinDuplicar.some(objeto => objeto.sku === skuSinUltimoApartado && objeto.idPedido == articulo.idPedido)) {
                const articuloSinDuplicado = { ...articulo, sku: skuSinUltimoApartado };
                articuloSinDuplicar.push(articuloSinDuplicado);
              }
            });

            this.listSku = articuloSinDuplicar.map(element => ({ sku: element.sku, titulo: element.titulo, variant: "outline-dark", idPedido: element.idPedido }));

             if(!autoload)
            {
              this.skuSelect = this.listSku[0].sku;
              this.tituloSelect = this.listSku[0].titulo;
              this.idPedidoSelect = this.listSku[0].idPedido;
            }
            
            this.obtenerColoresSku(autoload);

            if(!autoload){
              // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: this.idTareaTrabajando })
            }

             /*Aqui filtro segun la categoria que este seleccionada*/
            this.filtrarPiezas();
            this.coloresBotones();

            this.checkBloqueados();

            this.listSku.forEach(item => {
              item.cantidad = this.skuConfeccion.reduce((total, articulo) => {
                if (this.eliminarUltimoApartado(articulo.sku) == item.sku && item.idPedido == articulo.idPedido) {
                  return total + articulo.cantidad;
                }
                return total;
              }, 0);
            });

      },
      async loadItemsOptimizado(autoload = false){

      //try {
          /*Obtengo los sku de gestionar dia*/
          const responseConfeccionDia = await axios.get("/taller/master/confeccion/dia");
          const resConfeccionDia = responseConfeccionDia.data;
          
          const sku = resConfeccionDia.map(element => this.eliminarUltimoApartado(element.sku))
          this.skuConfeccion = resConfeccionDia;   

          const responsePieza = await axios.post("/confeccion/tarea/list", {list: [...new Set(sku)] });
          const resPieza = responsePieza.data;

          this.allTareas = resPieza;

          let ids = [];

          if (Array.isArray(resPieza)) {
            ids = resPieza.map(element => element.idLetra)
          }
          else
          {
            return;
          }

          const responseLetras = await axios.post("/confeccion/letra/id", {list: [...new Set(ids)] });
          const resLetras = responseLetras.data;

          this.allLetras = resLetras;

          this.allLetras.sort((a, b) => Number(a.orden) - Number(b.orden));

          /*Obtengo el estado de las piezas de ese pedido*/
          let skuPedido = this.skuConfeccion.flatMap(dato => {
            return this.allTareas
              .filter(tarea => tarea.sku === this.eliminarUltimoApartado(dato.sku))
              .map(tarea => ({ idPedido: dato.idPedido, idTarea: tarea.id, color: dato.sku.split('-').pop() }));
          });
          

          const responseTareaEstado = await axios.post("/taller/pieza/pedido/confeccion", {info: skuPedido });
          const resTareaEstado = responseTareaEstado.data;

          this.allTareas = resTareaEstado.map(tarea => {
            const finalizado = tarea.terminado > 0;
            return { ...tarea, finalizado };
          });

          this.allTareas.forEach((obj2) => {
            const obj1 = resPieza.find((obj1) => obj1.id === obj2.id);
            if (obj1) {
              obj2.sku = obj1.sku;
            }
          });

          this.allTareas.sort((a, b) => Number(a.orden) - Number(b.orden));

          //Quito el color del articulo y quito los duplicados (para mostrar arriba, el color ira dentro de cada uno)
          const articuloSinDuplicar = [];

          this.skuConfeccion.forEach(articulo => {
            const skuSinUltimoApartado = this.eliminarUltimoApartado(articulo.sku);
            
            if (!articuloSinDuplicar.some(objeto => objeto.sku === skuSinUltimoApartado && objeto.idPedido == articulo.idPedido)) {
              const articuloSinDuplicado = { ...articulo, sku: skuSinUltimoApartado };
              articuloSinDuplicar.push(articuloSinDuplicado);
            }
          });

          this.listSku = articuloSinDuplicar.map(element => ({ sku: element.sku, titulo: element.titulo, variant: "outline-dark", idPedido: element.idPedido }));

          if(!autoload)
          {
            this.skuSelect = this.listSku[0].sku;
            this.tituloSelect = this.listSku[0].titulo;
            this.idPedidoSelect = this.listSku[0].idPedido;
          }
          
          this.obtenerColoresSku(autoload);

          if(!autoload){
            // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: this.idTareaTrabajando })
          }

          /*Aqui filtro segun la categoria que este seleccionada*/
          this.filtrarPiezas();
          this.coloresBotones();

          this.checkBloqueados();

          this.listSku.forEach(item => {
            item.cantidad = this.skuConfeccion.reduce((total, articulo) => {
              if (this.eliminarUltimoApartado(articulo.sku) == item.sku && item.idPedido == articulo.idPedido) {
                return total + articulo.cantidad;
              }
              return total;
            }, 0);
          });

      },
      eliminarUltimoApartado(cadena) {
            const lastIndex = cadena.lastIndexOf("-");
            if (lastIndex !== -1) {
                return cadena.substring(0, lastIndex);
            }
            return cadena;
      },
      obtenerColoresSku(autoload){

        const coloresUnicos = new Set();
        this.coloresSku = [];

        this.allTareas.forEach(dato => {
          if (dato.sku === this.skuSelect && !coloresUnicos.has(dato.color) && dato.idPedido == this.idPedidoSelect) {
            coloresUnicos.add(dato.color);
            const cantidad = this.skuConfeccion.reduce((total, articulo) => {
              if (articulo.sku === `${dato.sku}-${dato.color}` && articulo.idPedido == this.idPedidoSelect) {
                return total + articulo.cantidad;
              }
              return total;
            }, 0);
            this.coloresSku.push({
              nombre: dato.color,
              variant: 'outline-dark',
              cantidad,
              sku: dato.sku,
              paso: "",
              idPedido: dato.idPedido
            });
          }
        });

        this.coloresSku.forEach(objeto => {
          const elementoFiltrado = this.skuConfeccion.find(elemento => elemento.sku === `${objeto.sku}-${objeto.nombre}`);
          if (elementoFiltrado) {
            objeto.orden = elementoFiltrado.orden;
          }
        });

        this.coloresSku.sort((a, b) => Number(a.orden) - Number(b.orden));

        if(this.coloresSku.length > 0 && !autoload)
          this.colorSelect = this.coloresSku[0].nombre;

      },
      filtrarPiezas(){
        this.tareas = [];

        this.allTareas.forEach(element => {
            if(element.color == this.colorSelect && element.sku == this.skuSelect && element.idPedido == this.idPedidoSelect)
            {
                this.tareas.push(element);
            }
        });

        // Crear un objeto auxiliar para almacenar las combinaciones únicas de categoría, color y SKU
        let uniqueCombos = {};

        // Filtrar los elementos y almacenar las combinaciones únicas en el objeto auxiliar
        this.tareas.forEach(element => {
          const combo = `${element.color}-${element.sku}-${element.id}`;
          if (uniqueCombos[combo]) {
            uniqueCombos[combo].finalizado = uniqueCombos[combo].finalizado && element.finalizado;
          } else {
            uniqueCombos[combo] = element;
          }
        });

        // Crear un nuevo array con los elementos únicos
        this.tareas = Object.values(uniqueCombos);

        //Busco la cantidad total de esa combinacion
        this.tareas.forEach(pieza => {
           const cantidad  = this.skuConfeccion.reduce((total, articulo) => {
                if (articulo.sku === `${pieza.sku}-${pieza.color}` && articulo.idPedido == pieza.idPedido) {
                  return total + articulo.cantidad;
                }
                return total;
              }, 0);

            pieza.fabricar = cantidad;

            const totalTerminado  = this.allTareas.reduce((total, articulo) => {
                if (pieza.id == articulo.id && articulo.color === pieza.color && articulo.idPedido == pieza.idPedido) {
                  return total + articulo.terminado;
                }
                return total;
              }, 0);

            pieza.terminadoTotal = totalTerminado;

            if(pieza.terminadoTotal > 0)
              pieza.finalizado = true;

            pieza.bloqueado = true;

            if(pieza.requierePrevio == 0)
              pieza.bloqueado = false;
        })

        this.filtraLetras();

      },
      coloresBotones()
      {
        ///Nombre productos
        this.listSku.forEach(item => {
          const allFinish = this.allTareas
            .filter(pieza => item.sku === pieza.sku && item.idPedido == pieza.idPedido)
            .every(pieza => pieza.finalizado);

          if (allFinish) {
            item.variant = "success";
          }
          else if (this.allTareas.some(pieza => item.sku === pieza.sku && (pieza.finalizado || pieza.iniciado) && item.idPedido == pieza.idPedido)) {
            item.variant = "warning";
          }
          else {
            item.variant = "outline-dark";
          }
        });


        //Color producto seleccionado
        this.coloresSku.forEach(item => {
          const allFinish = this.allTareas
            .filter(pieza => this.skuSelect === pieza.sku && pieza.color === item.nombre && item.idPedido == pieza.idPedido)
            .every(pieza => pieza.finalizado);

          if (allFinish) {
            item.variant = "success";
          }
          else if (this.allTareas.some(pieza => this.skuSelect === pieza.sku && pieza.color === item.nombre && (pieza.finalizado || pieza.iniciado) && pieza.idPedido == item.idPedido)) {
            item.variant = "warning";
          } else {
            item.variant = "outline-dark";
          }
        });
    
      },
      cambioColor(color){
        this.colorSelect = color;
        this.filtrarPiezas();
        this.coloresBotones();
        this.checkBloqueados();

        // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: -1})
      },
      cambioSku(data)
      {
        this.skuSelect = data.sku;
        this.tituloSelect = data.titulo;
        this.idPedidoSelect = data.idPedido;
        this.obtenerColoresSku();
        this.filtrarPiezas();
        this.coloresBotones();
        this.checkBloqueados();

        // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: -1})
      },
      seleccionarTipoReport(data)
      {
        this.reportTipo = data;

        if(this.reportTipo == 1 || this.reportTipo == 2)
        {
          setTimeout(()=>{this.$refs.descripcionReportInput.focus(); }, 300);
        }

      },
      reportModal(data)
      {
        if(data==null)
        {
          this.tareaReport = {nombreCategoria: this.tituloSelect + ' ' + this.colorSelect};
          this.cantidadObjetivo = 0;
          this.cantidadCortada = 0;
          this.reportTipo = 1;
        }
        else{
          this.tareaReport = data;
          this.cantidadObjetivo = data.fabricar;
          this.cantidadCortada = data.fabricar;
          this.reportTipo = 0;
        }

        this.$refs['modal-report'].show();
      },
      filtraLetras(){
        this.letras = [];

        const newArray = this.allLetras.map((letra) => {
          const tareasAsociadas = this.tareas.filter((tarea) => tarea.idLetra === letra.id && tarea.idPedido == this.idPedidoSelect);
          return { ...letra, bloqueado: true, finalizado: false, tareas: tareasAsociadas };
        });

        this.letras = newArray.filter(element => element.tareas.length > 0);

        let maxMano = 0;
        let maxAparado = 0;

        this.letras.forEach(letra => {
          letra.grupos = {};
          let contadorMano = 0;
          let contadorAparado = 0;
          let lastTipo = "";

          letra.tareas.forEach(tarea => {
            let tipo = tarea.tipo;
            let contador = tipo === "Mano" ? contadorMano : contadorAparado;
            let grupo = tipo === "Mano" ? "mano" : "aparado";

            if (lastTipo === "") {
              contador++;
              letra.grupos[grupo + contador] = [tarea];
              lastTipo = tipo;
            } else if (lastTipo !== tipo) {
              contador++;
              letra.grupos[grupo + contador] = [tarea];
              lastTipo = tipo;
            } else {
              letra.grupos[grupo + contador].push(tarea);
            }

            if (tipo === "Mano") {
              contadorMano = contador;
            } else {
              contadorAparado = contador;
            }

          });

          if(contadorMano > maxMano)
            maxMano = contadorMano;
          if(contadorAparado > maxAparado)
            maxAparado = contadorAparado;
        });

        this.columnasTable = [];

        this.gruposImagenes = []    
        
         this.columnasTable.push({
          key: "letraimg",
          label: "Terminado",
          thClass: 'columnSeparador',
          tdClass: 'columnSeparador'
        });

        for (let index = 1; index <= maxMano; index++) {
          if(index == maxMano)
          {
              this.columnasTable.push({
                key: "mano"+index,
                label: "Mano",
                thClass: 'columnSeparador',
                tdClass: 'columnSeparador'
              })
          }
          else
          {
            this.columnasTable.push({
              key: "mano"+index,
              label: "Mano",
            })
          }
          
          this.gruposImagenes.push({name: "mano"+index})
        }

        

        for (let index = 1; index <= maxAparado; index++) {
         
            this.columnasTable.push({
              key: "aparado"+index,
              label: "Aparado",
            })
          
          

          this.gruposImagenes.push({name: "aparado"+index})
        }
      

        /*,{
          key: "options",
          label: "Reportes",
          thStyle: { width: "5%" },
        }*/
      },
      getGrupoImagenes(item, grupoName)
      {
        for (const [grupo, tareas] of Object.entries(item.grupos)) {
          if(grupo == grupoName)
            return tareas;
        }
      },
      comprobarSiEstoyEnLaTarea(tarea)
      {
        this.idTareaTrabajando = tarea.idTareaPedido;
        const tareaEncontrada = this.confeccionUsers.find((tarea) => tarea.idUser === this.userId);

        if(tareaEncontrada.tarea == tarea.idTareaPedido)
        {
            return true;
        }
        else
        {
            // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: tarea.idTareaPedido })
            return false;
        }
      },
      cambiarEstadoTarea(data)
      {

        const tareasUpdate = [];

          this.allTareas.forEach(pieza => {
            if(pieza.id == data.id && pieza.color == data.color && pieza.sku == data.sku && pieza.idPedido == data.idPedido)
            {
              if(data.finalizado)
                pieza.terminado = pieza.pedido;

              if(!data.finalizado)
                pieza.terminado = 0;

              pieza.finalizado = data.finalizado;
              pieza.iniciado = data.iniciado;

              tareasUpdate.push({id: pieza.idTareaPedido, terminado: pieza.terminado, iniciado: pieza.iniciado});
            }
          });

        axios
              .put("/taller/tarea/completada", {data: tareasUpdate})
              .then(response => {
                  return response.data;
              })
              .then(res => {
                // this.$socket.emit('tareaconfeccion', { mensaje: 'Hola servidor' })
              });

        this.filtrarPiezas();

        this.checkBloqueados();
        this.$refs.tableCorte.refresh();
        this.coloresBotones();

      },
      tareaFinalizada(data) {

        if (data.bloqueado || !this.comprobarSiEstoyEnLaTarea(data)) {
          return;
        }

        const confirmOptions = {
          showCancelButton: true,
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        };

        if (data.finalizado) { //DESHACER
          this.$swal({
            title: '¿deshacer la tarea?',
            icon: 'error',            
            confirmButtonText: 'Si, deshacer',
            ...confirmOptions,
          }).then(result => {
            if (result.value) {
              data.finalizado = !data.finalizado;
              data.iniciado = 0;
              this.cambiarEstadoTarea(data);
            }
          });
        } else if (data.iniciado === 1) { //FINALIZAR
          this.$swal({
            title: 'finalizar la tarea?',
            icon: 'success',
            confirmButtonText: 'Si, finalizar',
            ...confirmOptions,
          }).then(result => {
            if (result.value) {
              data.finalizado = !data.finalizado;
              data.iniciado = 0;
              if (data.finalizado) {
                data.terminadoTotal = data.fabricar;
              }
              this.cambiarEstadoTarea(data);
            }
          });
        } else { //COMENZAR
          this.$swal({
            title: '¿comenzar la tarea?',
            icon: 'warning',
            confirmButtonText: 'Si, comenzar',
            ...confirmOptions,
          }).then(result => {
            if (result.value) {
              data.iniciado = 1;
              this.cambiarEstadoTarea(data);
            }
          });
        }
        /* ICONO PERSONALIZADO
        iconHtml: '<i class="fa-solid fa-play"></i>',
              customClass: {
                icon: 'no-border'
              },*/
      },
      tareaFinalizadaFuncional(data)
      {
        if(!data.bloqueado)
        {
          if(!this.comprobarSiEstoyEnLaTarea(data))
            return;

          if(data.finalizado)
          {
             this.$swal({
                title: '¿Estas seguro que quieres deshacer la tarea?',
                text: "",
                icon: 'error',
                showCancelButton: true,
                //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
                confirmButtonText: 'Si, deshacer',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {
                if (result.value) {

                  data.finalizado = !data.finalizado;
                  data.iniciado = 0;

                   this.cambiarEstadoTarea(data);
                }
              })
          }

          if(!data.finalizado)
          {
            if(data.iniciado == 1)
            {

              this.$swal({
                title: '¿Estas seguro que quieres finalizar la tarea?',
                text: "",
                icon: 'success',
                showCancelButton: true,
                //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
                confirmButtonText: 'Si, finalizar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {
                if (result.value) {

                   if(data.iniciado == 0)
                    data.iniciado = 1;
                  else
                  {
                    data.finalizado = !data.finalizado;
                    data.iniciado = 0;
                  }

                  if(data.finalizado)
                  {
                    data.terminadoTotal = data.fabricar;
                  }

                   this.cambiarEstadoTarea(data);
                }
              })

            }
            else
            {
              this.$swal({
                title: '¿Estas seguro que quieres comenzar la tarea?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
                confirmButtonText: 'Si, comenzar',
                cancelButtonText: 'No',
                customClass: {
                  confirmButton: 'btn btn-primary',
                  cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
              }).then(result => {
                if (result.value) {

                   if(data.iniciado == 0)
                    data.iniciado = 1;
                  else
                  {
                    data.finalizado = !data.finalizado;
                    data.iniciado = 0;
                  }

                  if(data.finalizado)
                  {
                    data.terminadoTotal = data.fabricar;
                  }

                   this.cambiarEstadoTarea(data);
                }
              })
            }
             
          }

        }

      },
      checkBloqueados()
      {
        // Crear un diccionario o mapa para almacenar las tareas por su ID
          const tareaPorId = {};
          this.letras.forEach(letra => {
            letra.tareas.forEach(tarea => {
              tareaPorId[tarea.id] = tarea;
            });
          });

          // Iterar nuevamente para actualizar el estado de las tareas
          this.letras.forEach(letra => {
  
              letra.tareas.forEach(tarea => {
                if (tarea.requierePrevio !== 0) {
                  const tareaBuscando = tareaPorId[tarea.requierePrevio];
                  if (tareaBuscando) {
                    if (tareaBuscando.bloqueado) {
                      tarea.bloqueado = true;
                    }
                    else if (tareaBuscando.finalizado || tareaBuscando.iniciado) {
                      tarea.bloqueado = false;
                    } 
                  }
                }
              });
            
          });

        this.letras.forEach(letra => {

              let auxBloqueado = false;
              for (let index = 0; index < letra.tareas.length - 1; index++) {
                if (letra.tareas[index].finalizado === false && letra.tareas[index].iniciado === 0) {
                  auxBloqueado = true;
                  //auxBloqueado = false;
                  break;
                }
              }

              letra.tareas[letra.tareas.length - 1].bloqueado = auxBloqueado;
            
        });


        this.letras.forEach(letra => {
          let auxFinalizado = true;
          let auxBloqueado = true;
          for (const [grupo, tareas] of Object.entries(letra.grupos)) {
            tareas.forEach(tarea => {
              if(!tarea.finalizado)
                auxFinalizado=false;

              if(!tarea.bloqueado)
                auxBloqueado = false;

            });
          }

          letra.finalizado = auxFinalizado;
          letra.bloqueado = auxBloqueado;
        });
      
      },
      guardarReporte()
      {
        const fechaActual = new Date();
        const dia = fechaActual.getDate().toString().padStart(2, '0');
        const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaActual.getFullYear().toString();

        let dataReport = {
          descripcion: this.descripcionReport, 
          categoria: 'Confeccion',
          sku: this.skuSelect,
          color: this.colorSelect,
          idPedido: this.idPedidoSelect,
          fecha: `${dia}-${mes}-${anio}`,
          seccion: 'Confeccion',
          fechaSolucionado: '',
          solucionado: 0,
          id: 0
        }

        axios
          .post("/taller/pieza/reporte", dataReport)
          .then(response => {
              return response.data;
          })
          .then(res => {

              this.$swal({
                  icon: 'success',
                  title: 'Report creado',
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })
          });

          this.$refs['modal-report'].hide();      
      }
    },
    mounted() {
      let user = JSON.parse(localStorage.getItem('userData'));
      this.userId = user.id;
      this.userName = user.nombre;

      //localStorage.setItem('userData', JSON.stringify(userData))
      this.loadItems();      
    },
    beforeDestroy() { 
      // this.$socket.emit('disconnectConfeccion', { idUser: this.userId })      
    },
    watch: {  
      confeccionUpdate(newValue, oldValue){
        //console.log("Evento desde el watch: " + newValue.data);
        this.loadItems(true);
      },
      confeccionUsers(newValue, oldValue){
        //console.log('Nuevos usuarios');
        this.confeccionUsers.forEach(item => {
          item.img = item.idUser + '.png';
        });
      },
      forceUpdateUser()
      {
        //console.log('force update');
        // this.$socket.emit('joinConfeccion', { idUser: this.userId, nombre: this.userName, zona: 'confeccion', sku: this.skuSelect, idPedido: this.idPedidoSelect, color: this.colorSelect, tarea: this.idTareaTrabajando })
      }
    },
    computed: {
      ...mapGetters('app', ['confeccionUpdate','confeccionUsers','forceUpdateUser']),
    },
  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .btn-circle{
    border-radius: 20px;
    padding: 12px;
    margin-right: 10px;
  }

  .btn-options{
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .div-imagenes{
    background-color: rgba(124, 255, 130, 0.35) ;
    border-radius: 15px;
  }

  .option-select{
    /*border: 2px solid #000000 !important;*/
    font-weight: bold; 
    font-size: 16px;
    /*box-shadow: 1px 1px 1px 2px rgba(255,255,255,1);*/
    //border: 2px solid #ffffff81 !important;
    box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -webkit-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -moz-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    //border-style: dotted !important;
  }

  .div-reporte{
    text-align: center;
    padding: 20px; 
    border-radius: 5px;
    border: 1px solid black;
  }

  .dark-layout .div-reporte{
    border: 1px solid white;
  } 

  .spinDisable button{
    display: none;
  }

  .div-imagenes-incompleta{
    background-color: rgba(255, 187, 78, 0.48);
  }

  .div-bloqueado{
    background-color: rgba(147, 147, 147, 0.48) !important;
    border-radius: 15px;
  }

  .div-proceso{
    background-color: rgba(255, 187, 78, 0.48);
    border-radius: 15px;
  }

  table th{
    text-align: center
  }

  .columnSeparador{      
    border-right: 5px solid #eeeeee !important;
  }

  .margin-avatar{
    margin-left: 5px
    //margin-right: -15px;
  }

  .margin-avatar-multiple{
    margin-left: -15px;
    //margin-right: -15px;
  }

  .seleccion-sku{
    position: sticky;
    top: 127px;
    background-color: white;
    z-index: 10;
  }

  .dark-layout .seleccion-sku{
    background-color: #283046 !important; 
  }

  @media (max-width: 1199px) {
  .seleccion-sku {
    position: sticky;
    top: 63px;
    background-color: white;
    z-index: 10;
  }
}

  /*.swal2-icon{
    border-color: transparent !important;
  }*/
</style>